import { Component, Input, OnInit, HostListener } from '@angular/core';
import { BandsService } from '@intranet/modules/admin';
import { BandGroup } from '@intranet/modules/admin/bands-types';

import * as moment from 'moment';

@Component({
    selector: 'client-pricebands',
    templateUrl: './client-pricebands.component.html',
    styleUrls: ['./client-pricebands.component.scss']
})
export class ClientPricebandsComponent implements OnInit {
    constructor(
        private bandService: BandsService,
      ) {}

    @Input() clientId: number;

    bandNames: string[] = [];
    bandGroups: BandGroup[] = [];
    showPriceBandDialog = false;

    newStartDate: Date;
    newRates: number[] = [];

    addError:string = '';
    deleteError:string = '';
    disableAddButton:boolean = false;
    public moment = moment;
    bandGroupToDelete: BandGroup | null = null;

    ngOnInit(): void {
        this.loadPriceBands();
    }

    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent): void {
      // Close confirmation modal on Ctrl+Q
      if (this.bandGroupToDelete && event.ctrlKey && event.key.toLowerCase() === 'q') {
        event.preventDefault();
        this.cancelDelete();
      }
    }

    loadPriceBands() {
        this.bandService.getClientPriceBands(this.clientId).subscribe({
            next: (r) => {
                if (r.success) {
                    this.bandNames = r.bandNames;
                    this.bandGroups = r.bandGroups;
                }
            }
        });
    }

    openAddDialog() {
        this.newStartDate = new Date();
        // initialise newRates to the most recent band rates
        if (this.bandGroups.length > 0) {
            this.newRates = this.bandGroups[this.bandGroups.length - 1].bands.map(b => b.bandRate);
        } else {
            this.newRates = this.bandNames.map(b => 0);
        }

        this.addError = '';
        this.showPriceBandDialog = true;
        this.disableAddButton = false;
    }

    confirmDeleteBandGroup(bandGroup: BandGroup) {
      this.bandGroupToDelete = bandGroup;
    }

    cancelDelete() {
      this.bandGroupToDelete = null;
    }

    doDeleteBandGroup() {
      if (this.bandGroupToDelete) {
        this.bandService.deleteClientPriceBands(this.clientId, this.bandGroupToDelete.startDate).subscribe({
          next: (r) => {
            if (r.success) {
              this.loadPriceBands();
              this.bandGroupToDelete = null;
            }
          },
          error: (e) => {
            this.deleteError = e.error.error;
            this.bandGroupToDelete = null;
          }
        });
      }
    }
}